import { AfterViewInit, Directive, Input, OnDestroy } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[luiMatFormFieldYearPicker]',
  standalone: true,
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'yyyy',
        },
        display: {
          dateInput: 'yyyy',
          monthYearLabel: 'yyyy',
          dateA11yLabel: 'yyyy',
          monthYearA11yLabel: 'yyyy',
        },
      },
    },
  ],
})
export class MatFormFieldYearPickerDirective
  implements AfterViewInit, OnDestroy
{
  destroyed$ = new Subject<void>();

  @Input('luiMatFormFieldYearPicker') datepicker!: MatDatepicker<unknown>;

  ngAfterViewInit(): void {
    if (!this.datepicker) {
      return;
    }
    this.datepicker.startView = 'multi-year';

    this.datepicker.yearSelected
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.datepicker.close());
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
